import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Redirect } from 'react-router-dom';
import {useEffect} from 'react'

interface IProps {
    title: string,
    message: string,
    type: string,
    redirect: boolean,
    url: string,
    accept: Function
}

interface IState {
    loading: boolean,
    visible: boolean
}

const sleep = (milliseconds: any) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}

const Result = (props:IProps) => {
    const [state, setState]=React.useState({
        loading:true,
        visible:true
    })
     

    async function redirect () {
        await sleep(4000)
        setState({...state, loading: false});
     }

    // public componentDidMount() {
    //     if (this.props.redirect)
    //         this.redirect();
    // }
    useEffect(() => {
        if (props.redirect){redirect()}
      }, [])


    const onAcceptar = (e: any) => {
        e.preventDefault();
        if (props.redirect)
            setState({...state, loading: false });
        else{
            props.accept();
        }
    }

     

        if (!state.loading && props.redirect) {
            return <Redirect to={'/' + props.url} />
        }

        const header = (
            <div className="pt-4">
                {(() => {
                    switch (props.type) {
                        case 'success':
                            return <div className="icon-box success-box">
                                <i className="pi pi-check" style={{ fontSize: '2rem' }}></i>
                            </div>
                        case 'info':
                            return <div className="icon-box info-box">
                                <i className="pi pi-info" style={{ fontSize: '2rem' }}></i>
                            </div>
                        case 'error':
                            return <div className="icon-box error-box ">
                                <i className="pi pi-times" style={{ fontSize: '2rem' }}></i>
                            </div>
                    }
                })()}
            </div >
        );
        const body = (
            <div className="result-box">
                <Dialog
                    visible={state.visible}
                    style={{ width: '300px' }}
                    modal={true}
                    closable={false}
                    header={header}
                    onHide={() => setState({...state, visible: false })}>
                    <h4 className="text-center">{props.title}</h4>
                    <div>
                        <p className="text-center">{props.message}</p>
                    </div>
                    <span className="box-center pt-4">
                        {(() => {
                            switch (props.type) {
                                case 'success':
                                    return <button className="btn btn-success btn-block" onClick={(e) => onAcceptar(e)} >Aceptar</button>
                                case 'info':
                                    return <button className="btn btn-primary btn-block" onClick={(e) => onAcceptar(e)}  >Aceptar</button>
                                case 'error':
                                    return <button className="btn btn-danger btn-block" onClick={(e) => onAcceptar(e)} >Aceptar</button>
                            }
                        })()}

                    </span>
                </Dialog >
            </div>
        );
        if (props.type == "") {
            return null
        }
        else {
            return (body)
        }
    }
 
export default Result